import React from 'react';
import { Card, CircularProgress, IconButton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';
import { FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import SubmitButtonDisplayer from 'app/components/SubmitButtonDisplayer';
import { checkAccess } from 'app/utils/roleFunctions';
import { ACCESS, ACCESS_SECTIONS } from 'app/utils/constants/access';


const ReceivalReadyNotifications = (props) => {
    const [enabled, setEnabled] = React.useState(props.notifications.length > 0);
    const [sms, setSms] = React.useState(props.notifications.length > 0 ? props.notifications[0].mobileBool : false);
    const [email, setEmail] = React.useState(props.notifications.length > 0 ? props.notifications[0].emailBool : false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [completed, setCompleted] = React.useState(false);
    const requiredMasterAccess = { key: ACCESS_SECTIONS.NOTIFICATIONS, value: ACCESS.MASTER };
    


    const onUpdate = (value) => {
        setEnabled(value)
    }
    const validate = () => {
        setLoading(true);
        setError(null);
        setCompleted(false);
        var oldNotifications = [...props.notifications];
        var newNotifications = [{ id: 0, functionId: props.functionId, owner: props.user, mobileBool: sms, emailBool: email, repeats: -1 }];
        if (!enabled) {
            newNotifications = [];
        }
        props.submit(oldNotifications, newNotifications).then((res) => {
            setLoading(false);
            setError(null);
        }).catch((err) => {
                setLoading(false);
                setCompleted(false);
                setError(err);
            }); 
    }
    return (
        <Grid container spacing={2}  >
            <Grid item xs={12} key={'a'}>
                <Typography variant='h3'>Receive notification when a receival is ready to be released</Typography>
                {/* switch */}
                <Switch checked={enabled} onChange={(event) => { onUpdate(event.target.checked) }} name="header-fixed" />
                {enabled ? "Enabled" : "Disabled"}
                <FormControlLabel
                    label={"Email"}
                    style={{ marginLeft: '20px' }}
                    control={
                        <Checkbox
                            checked={email}
                            onChange={(event) => { setEmail(event.target.checked) }}
                        />
                    }
                />
                <FormControlLabel
                    label={"SMS"}
                    control={
                        <Checkbox
                            checked={sms}
                            onChange={(event) => { setSms(event.target.checked) }}
                        />
                    }
                />
            </Grid>
            <Grid item xs={12} key={'ssa112sa'}>
             {checkAccess(props.access, requiredMasterAccess)?   <SubmitButtonDisplayer error={error} completed={completed} loading={loading} allowed={true} submitFunc={validate} handleClose={() => 1} />:"See Admin if you want to edit this notification"}
            </Grid>
        </Grid>
    );
}
export default ReceivalReadyNotifications;
